<template>
  <main class="main">
    <Product :product-id="+route.params.id" />
  </main>
  <Cookie />
</template>

<script setup>
import Product from "~/components/Section/Product/Product.vue";
import Cookie from "~/components/Section/Cookie.vue";

const route = useRoute();
</script>
